module.exports = __webpack_public_path__ + "static/media/ShadowsIntoLight-Regular.e8f47a72.ttf";